import React from "react";
import { AiFillCloseCircle } from "react-icons/ai";

const AddPayment_Form = ({ setPaymentModal }) => {
  return (
    <div className="flex items-center justify-center fixed inset-0 z-50  w-full min-h-screen bg-[#0000003f] p-4">
      <div className="relative bg-white p-6 sm:p-8 rounded-lg shadow-lg w-full max-w-lg md:max-w-2xl lg:max-w-5xl">
        <div className="mb-6">
          <h2 className="text-xl sm:text-2xl font-semibold text-primaryTextColor text-center">
            Add Payment
          </h2>
          <AiFillCloseCircle
            onClick={() => {
              setPaymentModal(false);
            }}
            class="cursor-pointer absolute top-4 right-4 "
            size={30}
            color="#e24c4b"
          />{" "}
        </div>

        <form className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {/* Name Input */}
          <div>
            <label className="block text-sm text-gray-600">Name</label>
            <input
              type="text"
              placeholder="Sidhartha"
              className="w-full px-4 py-2 mt-1 border rounded-lg text-primaryTextColor focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {/* Mobile Number Input */}
          <div>
            <label className="block text-sm text-gray-600">Mobile Number</label>
            <input
              type="text"
              placeholder="+91 5861 598 589"
              className="w-full px-4 py-2 mt-1 border rounded-lg text-primaryTextColor focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {/* Check In Input */}
          <div>
            <label className="block text-sm text-gray-600">Check In *</label>
            <input
              type="text"
              placeholder="dd/mm/yyyy"
              className="w-full px-4 py-2 mt-1 border rounded-lg text-primaryTextColor focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {/* Room No Input */}
          <div>
            <label className="block text-sm text-gray-600">Room No</label>
            <input
              type="text"
              placeholder="205"
              className="w-full px-4 py-2 mt-1 border rounded-lg text-primaryTextColor focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {/* Bed No Input */}
          <div>
            <label className="block text-sm text-gray-600">Bed No</label>
            <input
              type="text"
              placeholder="G-20"
              className="w-full px-4 py-2 mt-1 border rounded-lg text-primaryTextColor focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {/* Amount Input */}
          <div>
            <label className="block text-sm text-gray-600">Amount</label>
            <input
              type="text"
              placeholder="6890"
              className="w-full px-4 py-2 mt-1 border rounded-lg text-primaryTextColor focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {/* Mode of Payment Select */}
          <div>
            <label className="block text-sm text-gray-600">
              Mode of Payment
            </label>
            <select className="w-full px-4 py-2 mt-1 border rounded-lg text-primaryTextColor focus:ring-blue-500 focus:border-blue-500">
              <option>Cash</option>
              <option>UPI</option>
              <option>Online Transfer</option>
            </select>
          </div>

          {/* Payment Category Select */}
          <div>
            <label className="block text-sm text-gray-600">
              Payment Category
            </label>
            <select className="w-full px-4 py-2 mt-1 border rounded-lg text-primaryTextColor focus:ring-blue-500 focus:border-blue-500">
              <option>Rent</option>
              <option>Electricity</option>
              <option>Dues</option>
              <option>Security Deposite</option>
              <option>Others</option>
            </select>
          </div>

          {/* Buttons */}
          <div className="col-span-1 sm:col-span-2 flex justify-between mt-6">
            <button
              onClick={() => {
                setPaymentModal(false);
              }}
              type="button"
              className="w-full sm:w-1/2 py-2 border rounded-lg text-gray-600 font-semibold mr-0 sm:mr-2 hover:bg-gray-100"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="w-full sm:w-1/2 py-2 bg-[#4379EE] text-white rounded-lg font-semibold mt-4 sm:mt-0 sm:ml-2 hover:bg-blue-700"
            >
              Checkout
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddPayment_Form;
